import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customValueHandling' })
export class CustomValueHandlingPipe implements PipeTransform {
  private datetimeColumns = [
    'created_dttm',
    'last_updated_dttm',
    'deleted_dttm',
    'start_date',
    'end_date',
    'next_run_time',
    'last_run_time',
    'created_ts',
    'last_updated_ts',
    'create_timestamp',
    'registration_date',
    'min_utc_reg_date'
  ];

  public transform(value: any, column: string): any {
    if (this.datetimeColumns.includes(column)) {
      if (!value) {
        return undefined;
      }
      enum months {
        Jan,
        Feb,
        Mar,
        Apr,
        May,
        Jun,
        Jul,
        Aug,
        Sep,
        Oct,
        Nov,
        Dec
      }

      const timestamp = new Date(Number(value) * 1000);
      const year = timestamp.getFullYear();
      const month = months[timestamp.getMonth()];
      const day = timestamp.getDate();
      const hours = ((timestamp.getHours() + 11) % 12) + 1;
      const minutes = String(timestamp.getMinutes()).padStart(2, '0');
      const meridiem = timestamp.getHours() > 12 ? 'PM' : 'AM';

      return `${year}/${month}/${day} ${hours}:${minutes} ${meridiem}`;
    }
    if (value) {
      if (value.constructor.name === 'Array') {
        return value.length;
      }
      if (value.constructor.name === 'Number' && !column.includes('id')) {
        return new Intl.NumberFormat().format(value);
      }
    }

    return value;
  }
}
